import type { CamundaFormValues } from '@/lib/camunda/types';

import schema from './schema';

/** Adapta la decisión final al contrato de variables del proceso laboral. */
export function prepareAnalisisLaboralSubmission(values: CamundaFormValues): CamundaFormValues {
  const analysis = schema.parse(values);
  if (analysis.mas_info === '1') {
    return { ...values, ...analysis };
  }

  const decision = {
    ...values,
    ...analysis,
    // El listener de historial consume nuevoTexto. decision_comment se conserva
    // para la consulta posterior de la decisión; el borrador no se modifica.
    nuevoTexto: analysis.decision_comment,
  };
  if (analysis.accion_disiplinaria !== '2') {
    return { ...decision, fechaSancionInicio: null, fechaSancionFin: null };
  }
  return decision;
}
